import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  button: {
    margin: "0 4px",
    padding: "2px 4px",
  },
  input: {
    display: "none",
  },
});

function SimpleTable(props) {
  const { classes, headers, rows } = props;

  return (
    <Paper className={classes.root} elevation={0}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {headers &&
              headers.map(header => (
                <TableCell key={header.key}>{header.alias}</TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows &&
            rows.map((row, index) => (
              <TableRow key={index}>
                {headers &&
                  headers.map(header => (
                    <TableCell key={header.key}>{row[header.key]}</TableCell>
                  ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

SimpleTable.defaultProps = {
  headers: [],
  rows: [],
};

SimpleTable.propTypes = {
  classes: PropTypes.object.isRequired,
  headers: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  moduleName: PropTypes.string.isRequired,
};

export default withStyles(styles)(SimpleTable);
